import {inject, Injectable} from "@angular/core";
import {HttpRepository} from "./http.repository";
import {Observable} from "rxjs";
import {ClonedLineMapping, ClonedLineMappingHelper} from "../interfaces/rest/ClonedLineMapping";
import {UserSessionRepository} from "./user-session.repository";
import {GlobalConfig} from "../configs/GlobalConfig";

@Injectable({
  providedIn: 'root'
})
export class ClonedLineMappingRepository {

  private readonly httpRepository = inject(HttpRepository);
  private readonly userSessionRepository = inject(UserSessionRepository);

  private cache: Array<ClonedLineMapping>|null = null;

  constructor() {

  }

  getClonedLineMappings(): Observable<Array<ClonedLineMapping>> {
    return new Observable((subscriber) => {
      if(this.cache !== null) {
        subscriber.next(this.cache);
        subscriber.complete();
      }
      else {
        let endpoint = GlobalConfig.endpoints.cloneLineMappings;
        const currentUser = this.userSessionRepository.getUserSession();

        if(currentUser && currentUser.userType === 'subuser') {
          endpoint += ('?userId=' + currentUser.userId);
        }

        this.httpRepository.get<Array<ClonedLineMapping>>(endpoint).subscribe({
          next: (data) => {
            if(data) {
              this.cache = data;
              this.cache.forEach((mapping) => {
                ClonedLineMappingHelper.populateAliases(mapping);
              });
              subscriber.next(this.cache);
            }
            else {
              subscriber.next([]);
            }
          },
          error: (error) => {
            subscriber.error(error);
          },
          complete: () => {
            subscriber.complete();
          }
        });
      }
    });
  }

  getClonedLineMappingsFromCache(): Array<ClonedLineMapping>|null {
    return this.cache;
  }

  clearCache(): void {
    this.cache = null;
  }
}
